<template>
    <h3 class="form-section" style="margin-top: 0">{{ title }}</h3>
</template>

<script>
export default {
  props:{
    title: {
      type: String,
      default: ''
    }
  },

}

</script>
